import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class InitService {

  constructor(
    private _shared:SharedService
  ) { }

  get_auth_token() {
  	var token = this._shared.getToken();
    return token;
  }

  get_local_key(keyname){
    /*
    Gets data from local storgae given key name.
    */
    var data = localStorage.getItem(keyname);
    return data;
  }

}
